import { Ruler, Sofa, BedDouble, Layers, Truck, Zap } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { TIPS, TIPS_INTRO } from "../data/site";

const icons = {
  ruler: Ruler,
  sofa: Sofa,
  bed: BedDouble,
  layers: Layers,
  truck: Truck,
  zap: Zap,
};

export const Tips = () => (
  <section id="tanacsok" data-testid="tips-section" className="scroll-mt-24 bg-cream2 py-24 sm:py-28">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <SectionHeading eyebrow={TIPS_INTRO.eyebrow} title={TIPS_INTRO.title} sub={TIPS_INTRO.text} />

      <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {TIPS.map((tip, i) => {
          const Icon = icons[tip.icon];
          return (
            <Reveal key={tip.title} delay={(i % 3) * 0.08}>
              <article
                data-testid={`tip-card-${i}`}
                className="h-full rounded-3xl border border-line bg-white p-8 card-shadow transition-transform duration-300 hover:-translate-y-1"
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-burgundy/10 text-burgundy">
                  <Icon className="h-[22px] w-[22px]" />
                </span>
                <h3 className="mt-5 font-display text-xl font-semibold text-ink">
                  <span className="mr-2 text-gold">{String(i + 1).padStart(2, "0")}.</span>
                  {tip.title}
                </h3>
                <p className="mt-2.5 text-sm leading-relaxed text-soft">{tip.text}</p>
              </article>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
